import React from 'react';
import './Common_breadcrumb.css';
import Breadcrumb from "react-bootstrap/Breadcrumb";

const Common_breadcrumb = ({ 
    pageName = "PAGE NAME", 
    bgImage = '/assets/images/lesson/bg/bg.png', 
    breadcrumbs = [{ name: "HOMEPAGE", href: "#" }, { name: "CURRENT PAGE", active: true }]
}) => {
    return (
        <div className='container'>
            <section className='Common_breadcrumb_sec'>
                <div className='braedbox'>
                    <div className='imgdiv'>
                        <img className='bgimg' src={process.env.PUBLIC_URL + bgImage} alt="background"/>
                        <div className='colordiv'></div>
                    </div>
                    <div className='overlaydata'>
                        <h1 className='pagename'>{pageName}</h1>
                        <div className='bdbot'></div>
                        <div className="Breadcrumb_comp">
                            <Breadcrumb>
                                {breadcrumbs.map((item, index) => (
                                    <Breadcrumb.Item 
                                        key={index} 
                                        href={item.href} 
                                        active={item.active || false}
                                    >
                                        {item.name}
                                    </Breadcrumb.Item>
                                ))}
                            </Breadcrumb>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Common_breadcrumb;
